import createSelector from "../../utils/reselect";

const projectsStateData = (state) => {
  const { projects } = state;
  return projects || {};
};

export const getError = createSelector(projectsStateData, (projects) =>
  projects.get("error")
);

//GET PROJECTS
export const projects = createSelector(projectsStateData, (projects) =>
  projects.get("projects")
);

export const projectsLoading = createSelector(projectsStateData, (projects) =>
  projects.get("projectsLoading")
);

export const projectLoading = createSelector(projectsStateData, (projects) =>
  projects.get("projectLoading")
);

export const overviewLoader = createSelector(projectsStateData, (projects) =>
  projects.get("overviewLoader")
);

export const projectPagination = createSelector(projectsStateData, (projects) =>
  projects.get("projectPagination")
);

export const project = createSelector(projectsStateData, (projects) =>
  projects.get("project")
);
export const projectBudgetSummary = createSelector(projectsStateData, (projects) =>
  projects.get("projectBudgetSummary")
);
export const projectProgressSummary = createSelector(projectsStateData, (projects) =>
  projects.get("projectProgressSummary")
);
export const projectBudgetSummaryLoading = createSelector(projectsStateData, (projects) =>
  projects.get("projectBudgetSummaryLoading")
);
export const projectProgressSummaryLoading = createSelector(projectsStateData, (projects) =>
  projects.get("projectProgressSummaryLoading")
);

export const projectStatusLoading = createSelector(
  projectsStateData,
  (projects) => projects.get("projectStatusLoading")
);

export const saveProjectLoading = createSelector(
  projectsStateData,
  (projects) => projects.get("saveProjectLoading")
);

export const projectPrograms = createSelector(projectsStateData, (projects) =>
  projects.get("projectPrograms")
);
export const managers = createSelector(projectsStateData, (projects) =>
  projects.get("managers")
);
export const resources = createSelector(projectsStateData, (projects) =>
  projects.get("resources")
);

export const report = createSelector(projectsStateData, (projects) =>
  projects.get("report")
);

export const reportLoading = createSelector(projectsStateData, (projects) =>
  projects.get("reportLoading")
);

export const confirmedReport = createSelector(projectsStateData, (projects) =>
  projects.get("confirmedReport")
);

export const confirmReportLoading = createSelector(projectsStateData, (projects) =>
  projects.get("confirmReportLoading")
);

// /////////////////////////PROJECT RESOURCES/////////////////////////////

export const resourcesStatusLoading = createSelector(
  projectsStateData,
  (projects) => projects.get("resourcesStatusLoading")
);

export const allocatedResources = createSelector(
  projectsStateData,
  (projects) => projects.get("allocatedResources")
);

export const allocatedResourcesPagination = createSelector(
  projectsStateData,
  (projects) => projects.get("allocatedResourcesPagination")
);

// ///////////////////////// HEALTH STATUS /////////////////////////////

export const allMetrix = createSelector(projectsStateData, (projects) =>
  projects.get("metrix")
);

export const metrixLoading = createSelector(projectsStateData, (projects) =>
  projects.get("metrixLoading")
);
